<template>
  <div id="app" :class="isFullscreen == true ? 'web-app' : ''">
    <!--  头部显示  -->
    <body-header v-if="$route.meta.isHaveTop"></body-header>
    <!--  头部显示-结束  -->

    <!--  中间显示  -->
    <router-view />
    <!--  中间显示-结束  -->

    <!-- 浮窗-联系我们-->
    <contact-us-fixed v-if="$route.meta.isHaveContact"></contact-us-fixed>

    <!--  底部显示  -->
    <body-footer v-if="$route.meta.isHaveBottom"></body-footer>
    <!--  底部显示-结束  -->
    <Dialog></Dialog>
  </div>
</template>

<script>
import { mapMutations, mapGetters} from 'vuex'
import BodyFooter from "./components/BodyFooter";
import BodyHeader from "./components/BodyHeader";
// 登录
import Dialog from "@/views/Dialog/index"
import ContactUsFixed from "./components/contactUsFixed";
import {axiosConfig} from "@/config/project.config"
export default {
  name: 'app',
  components: {BodyHeader, BodyFooter, Dialog, ContactUsFixed},
  data () {
    return {
      isFullscreen: false,
    }
  },
  created() {

  },
  methods: {
    ...mapMutations([
        'changeSearchCondition',        
        'changeSearchVal'
    ]),
    // 添加判断方法
	  isMobile() {
      console.log(location.host) 
      console.log(location.href)
      var detailId = location.href.split("=")[1]
      if (/Android|webOS|iPhone|ipad|iPod|BlackBerry/i.test(navigator.userAgent)||navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger') {
        window.location.href = axiosConfig.shareAddress + '/wap/#/'        
        if(location.href.substring( location.href.indexOf("#"), location.href.indexOf("?"))=='#/course/detail'){
          window.location.href = axiosConfig.shareAddress + '/wap/#/goodDetail?id='+detailId
        }
      }	   	
	  },    
  },
  mounted(){
    // this.isMobile();
  },
  watch: {
   
  }
}
</script>

<style lang="less">
html,body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}
.web-app {
  width: 100%;
  height: 100%;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  position: relative;
  cursor: default;
  // background-color: #f5f6f6;
}
#common-header{
  font-size: 90px;
}
#common-footer{
  font-size: 90px;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #fbc51d !important;
    color: #FFF;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #fbc51d !important;
}
.el-button--primary {
  background-color: #fbc51d !important;
}
</style>
